__turbopack_context__.v({
  "bentoImage": "Integration-module__ea9zMa__bentoImage",
  "carouselWrap": "Integration-module__ea9zMa__carouselWrap",
  "heading": "Integration-module__ea9zMa__heading",
  "heightFitImage": "Integration-module__ea9zMa__heightFitImage",
  "naturalFitImage": "Integration-module__ea9zMa__naturalFitImage",
  "section": "Integration-module__ea9zMa__section",
});
